import {PublicHeader} from '../../components/public-header/PublicHeader'
import {Outlet} from 'react-router-dom'
import {PublicLayoutWrapper} from './style'
import {Snackbar} from '../../components/snackbar/Snackbar'
import {IS_REDIRECT_ENABLED} from '../../helpers/constants'

export const PublicLayout = () => {
    if (IS_REDIRECT_ENABLED) {
        return <Outlet />
    }

    return (
        <PublicLayoutWrapper id="public-layout">
            <PublicHeader />
            <Outlet />
            <Snackbar />
        </PublicLayoutWrapper>
    )
}
